import base from "../../baseurl";
import token from "../../getTk";

const Create = async (title, img, body, url, id) => {
  console.log(title, img, body, url, id);
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const newS = await api
    .post("indets/update", {
      json: { title, img, body, url, id },
      timeout: false,
    })
    .json();
  return newS;
};

export default Create;
